import React from "react";
import css from "./NotFoundScreen.module.css";
import {Navigate,useLocation} from "react-router-dom";



export default function NotFoundScreen(){
    const {pathname,hash}=useLocation();
    return (
        <Navigate to={pathname.replace(/\/+/g,"/")+hash} replace/>
    )
}

